import { Ng1StateDeclaration } from "@uirouter/angularjs";
import { modal } from "@gtmhub/core/routing";

export const filterStates = (base: string): Ng1StateDeclaration[] => [
  modal({
    name: `${base}._filter`,
    view: "filterform",
    windowClass: "medium-small filter-modal",
    abstract: true,
    data: {
      trackingPage: "Assignees Filter Form",
    },
    url: "filter/",
  }),
  {
    name: `${base}._filter.filter`,
    url: ":formFilterId/",
    data: {
      modal: null,
      requiresLogin: true,
      trackingPage: "Assignees Current Filter Form",
    },
    views: {
      "filterform@": {
        template: require("./views/filter-form.html"),
        controller: "FilterFormCtrl",
      },
    },
  },
];
